/* eslint-disable react-hooks/exhaustive-deps */

import React, { Fragment, useRef, useEffect, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { ViewForm } from './blocks';
import { useParams } from "react-router-dom";
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import scheduleActions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import ScheduleLines from './ScheduleLines';


const ScheduleTransactionsView = (props) => {
    const { readDetails, readError, getList, getData } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { instanceDetails } = useSelector(state => state.scheduleInstanceReducer);

    const dispatch = useDispatch();
    const { history } = props;
    const [loadMore, setLoadMore] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const { batchId } = useParams();
    const childRef = useRef('');

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission(`Schedule Transactions`, 'view', history, 'Admin')) {
            if (batchId === undefined) {
                history.push("/admin/batch-process/schedule-transactions");
                return true;
            }
            dispatch({ type: crudActions.READ_DETAILS_START, id: batchId, url: 'v1/schedule-instance/customer-schedule-instances' });
            childRef?.current?.handleAdjustHeight();
        }
    }, [roleManagement]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            dispatch({
                type: crudActions.GET_DETAILS_START,
                url: 'v1/schedule-instance/customer-schedule-instance-products',
                skip: 0,
                filter: {
                    where: { scheduleInstanceId: batchId }
                }
            });
            dispatch({
                type: scheduleActions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_START,
                url: 'v1/schedule-instance/customer-schedule-instance-details',
                skip: 0,
                filter: {
                    where: { scheduleInstanceId: batchId }
                }
            });
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            toast.dismiss();
            toast.error(readError);
            history.push('/admin/batch-process/schedule-transactions');
        }
    }, [readDetails, readError]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                } else {
                    setLoadMore(true);
                }
            });
            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Batch Process', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Schedule Details'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    !showDetails ? readDetails &&
                                        <ViewForm
                                            form={readDetails}
                                            classes={classes} clsx={clsx}
                                        /> : <div style={{ textAlign: "center" }}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div>
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={"Schedule Lines"}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                {
                                    !loadMore ? <div style={{ textAlign: "center" }}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div> : <ScheduleLines
                                        classes={classes}
                                        clsx={clsx}
                                        details={getList}
                                        instanceDetails={instanceDetails}
                                        form={readDetails}
                                        loadMore={loadMore}
                                    />
                                }
                            </>
                        }
                    />
                </div>
            </div>
        </Fragment>
    );
}

export default ScheduleTransactionsView;